import { Button } from 'antd'
import ContentHeader from '../ContentHeader'
import { ReactComponent as BarrierIcon } from '../img/ic_barrier.svg'
import { useI18n } from 'contexts/AuthContext'
import { getFitOnHost } from 'apis/formatUrl'
import { getAutoLoginParams } from 'utils/basic'
import { useDeeplink } from 'hooks/useDeeplink'

const GenericScreen = (props) => {
  const { i18n } = useI18n()
  const { fitonUserId, email } = useDeeplink()

  const onClose = () => {
    if (fitonUserId && email) {
      window.location.href = `${getFitOnHost()}${`?${getAutoLoginParams({ fitOnUserId: fitonUserId, fitOnEmail: email })}`}`
    } else {
      window.location.href = `${getFitOnHost()}`
    }
  }

  return (
    <div
      className='info-sec'
      style={{ height: '100vh', backgroundColor: 'white' }}
    >
      <ContentHeader {...props} hideBack showTopCorner={false} />
      <div
        className='info-content'
        style={{
          alignItems: 'center',
          height: 'calc(100vh - 88px)',
          justifyContent: 'center',
          padding: '0',
        }}
      >
        <BarrierIcon />
        <h1 className='title-pns' style={{ marginInline: '32px' }}>
          {i18n('This program is temporarily paused')}
        </h1>
        <p className='subtitle' style={{ marginTop: '0' }}>
          {i18n('Please check again soon')}
        </p>
        <Button
          className='btn-primary large-btn'
          style={{ marginTop: '32px' }}
          onClick={onClose}
        >
          {i18n('OK')}
        </Button>
      </div>
    </div>
  )
}

export default GenericScreen
